import React from 'react'
import DeliveryNoteDetails from '../Components/Admin/DeliveryNoteDetails'

function DeliveryNoteDetailsPage() {
  return (
    <div className="deliverynote-details-page min-h-screen bg-[#f8fafc]">
      <DeliveryNoteDetails />
    </div>
  )
}

export default DeliveryNoteDetailsPage
